import axios from "axios";
import Authentication from "services/authentication";
import get from "utils/get";

let auth;

const buildHeaders = () => {
  if (!auth) {
    auth = new Authentication();
  }

  let accessToken;
  if (auth.isAuthenticated()) {
    const token = auth.getAccessToken();
    accessToken = get(token, "idToken");
    return {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json;charset=UTF-8",
    };
  }
  return {};
};

const baseRequest = (url, options = {}) => {
  const { headers = {}, method = "get", ...opts } = options;

  return axios(url, {
    method: method,
    headers: { ...buildHeaders(), ...headers },
    ...opts,
  });
};

export default baseRequest;
